import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { Pencil } from "lucide-react";
import pageData from "./pageData.json";
const API_URL = process.env.REACT_APP_API_URL;

const Ads = () => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPage, setSelectedPage] = useState("home");
  const [selectedLocation, setSelectedLocation] = useState("");
  const navigate = useNavigate();

  const fetchAds = async (page, location = "") => {
    setLoading(true);
    try {
      let url = `${API_URL}/ads/getAllAds?page=${page}`;
      if (location) url += `&location=${location}`;

      const response = await fetch(url);
      const data = await response.json();
      setAds(data.ads);
    } catch (error) {
      console.error("Error fetching ads:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAds(selectedPage, selectedLocation);
  }, [selectedPage, selectedLocation]);

  const handlePageChange = (e) => {
    const newPage = e.target.value;
    setSelectedPage(newPage);
    setSelectedLocation(""); // Reset location when page changes
  };

  const handleLocationChange = (e) => {
    setSelectedLocation(e.target.value);
  };

  const columns = [
    {
      name: "Location",
      selector: (row) => row.location || "N/A",
      sortable: true,
    },
    {
      name: "Ad Type",
      selector: (row) => row.adType,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) =>
        new Date(row.createdAt).toLocaleString("en-IN", {
          dateStyle: "medium",
          timeStyle: "short",
        }),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          onClick={() => navigate(`/ads/edit/${row._id}`)}
          className="text-blue-600 hover:text-blue-800"
          title="Edit"
        >
          <Pencil size={18} />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const pageOptions = Object.keys(pageData);
  const locationOptions = pageData[selectedPage] || [];

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
        <h2 className="text-xl font-bold">All Ads</h2>
        <div className="flex gap-4 flex-wrap items-center">
          <select
            value={selectedPage}
            onChange={handlePageChange}
            className="border px-3 py-2 rounded"
          >
            {pageOptions.map((page) => (
              <option key={page} value={page}>
                {page.charAt(0).toUpperCase() + page.slice(1)} Page
              </option>
            ))}
          </select>

       

          <button
            onClick={() => navigate("/ads/add")}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            Add Ad
          </button>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={ads}
        progressPending={loading}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
      />
    </div>
  );
};

export default Ads;
